// extracted by mini-css-extract-plugin
export var wrapper = "j_b";
export var footer = "j_5";
export var contentBlock = "j_6";
export var contentBlockHeading = "j_7";
export var linkWrapper = "j_8";
export var link = "j_X";
export var external = "j_Y";
export var contactUs = "j_9";
export var btnGroup = "j_bb";
export var btn = "j_bc";
export var subscribe = "j_bd";